import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import money, { Money, format } from '../../lib/money';
import '../../css/share-details.css';

class LikelyShareWithDeposit extends Component {
  get amount() {
    return money(this.props.amount);
  }

  get depositAmount() {
    return money(this.props.depositAmount);
  }

  renderBreakdown() {
    return (
      <div>
        <div className="row">
          <div className="col-6 small-print">
            <FormattedMessage
              id="likelyShare.withDeposit.breakdown.share"
              defaultMessage="Your share & fee:"
            />
          </div>
          <div className="col-6 small-print text-right">
            {format(this.amount)}
          </div>
        </div>
        <div className="row">
          <div className="col-6 small-print">
            <FormattedMessage
              id="likelyShare.withDeposit.breakdown.deposit"
              defaultMessage="Deposit paid:"
            />
          </div>
          <div className="col-6 small-print text-right">
            ({format(this.depositAmount)})
          </div>
        </div>
        <hr className="py-0 my-1" />
        {this.renderExpectedBalance()}
      </div>
    );
  }

  renderExpectedBalance() {
    const balance = Money.subtract(this.amount, this.depositAmount);
    const textClass = balance.amountCents >= 0 ? '' : 'emerald-green';
    const text = balance.amountCents >= 0 ?
      <FormattedMessage
        id="likelyShare.withDeposit.expectedBalance"
        defaultMessage="Expected balance"
      /> :
      <FormattedMessage
        id="likelyShare.withDeposit.expectedRefund"
        defaultMessage="Expected refund"
      />;

    return (
      <div className="row mb-1">
        <div className="col-7 pr-0">{text}</div>
        <div className={`col-5 text-right ${textClass}`}>
          {format(balance)}
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className="share-details pl-2 py-1 sapphire-blue">
        <h4>
          <FormattedMessage
            id="likelyShare.withDeposit.title"
            defaultMessage="Your likely share"
          />
          <br />
          <span className="small-print">
            <FormattedMessage
              id="likelyShare.withDeposit.basedOn"
              defaultMessage="Based on estimated group size"
            />
          </span>
        </h4>
        {this.renderBreakdown()}
      </div>
    );
  }
}

LikelyShareWithDeposit.defaultProps = {
  amount: null,
  depositAmount: null,
};

export default LikelyShareWithDeposit;



// WEBPACK FOOTER //
// ./src/desktop/components/commit-form/likely-share.with-deposit.js